import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  marketingChannelWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  marketingHeaderWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    paddingBottom: 20,
  },
  marketingFormWrapper: {
    backgroundColor: colors.white,
    borderRadius: 8,
    padding: 30,
    marginTop: 20,
    marginBottom: 20,
  },
  marketingButtonWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    marginTop: 20,
    marginLeft: 'auto',
  },
  patientDropdownContainer: {
    backgroundColor: colors.white,
    borderRadius: 8,
    shadowColor: colors.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  patientDropdownStyle: {
    backgroundColor: colors.white,
    borderWidth: 1,
    borderColor: colors.grey,
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
    minWidth: '100%',
    marginBottom: 16,
  },
  patientDropdownTextStyle: {
    color: colors.black,
    fontSize: 18,
  },
  patientLabel: {
    fontSize: 16,
    fontWeight: '600',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: 8,
  },
});
